import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LightUserModel } from '../../../shared/data/models/light-user.model';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import { SocialUserService } from '../../shared-home/services/social-user.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConnectUsersService } from '../../shared-home/services/connect-users.service';

@Component({
  selector: 'anms-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss']
})
export class ProfileCardComponent implements OnInit, OnDestroy {
  @Input() lightUser: LightUserModel;
  @Input() currentUser: MiniUserModel;

  user$ = new Subject<MiniUserModel>();

  private unSubscribed = new Subject();

  loading$ = new BehaviorSubject<boolean>(false);
  error$ = new BehaviorSubject<string>('');

  constructor(
    private socialUserService: SocialUserService,
    private connectUsersService: ConnectUsersService
  ) {
    this.user$.next(null);
  }

  ngOnInit(): void {
    if (
      this.currentUser &&
      this.currentUser?.handle !== this.lightUser?.handle
    ) {
      this.getUser();
    }
  }

  getUser(): void {
    this.loading$.next(true);

    this.socialUserService
      .getUser({ handle: this.lightUser?.handle })
      .pipe(takeUntil(this.unSubscribed))
      .subscribe(
        res => {
          this.loading$.next(false);

          if (res.errors) {
            this.error$.next(res.errors[0].message);
          } else {
            this.user$.next(res?.data?.user);
            console.error(res.data.user);
          }
        },
        error => {
          this.error$.next(error);
          this.loading$.next(false);
        }
      );
  }

  followUser(): void {
    this.loading$.next(true);
    // this.user$.next(null);

    this.connectUsersService
      .followUser({ followeeId: this.lightUser?.ID })
      .pipe(takeUntil(this.unSubscribed))
      .subscribe(
        res => {
          this.loading$.next(false);

          if (res.errors) {
            this.error$.next(res.errors[0].message);
          } else {
            this.user$.next(res?.data?.follow.modifiedUser);
          }
        },
        error => {
          this.error$.next(error);
          this.loading$.next(false);
        }
      );
  }

  unFollowUser(): void {
    // this.user$.next(null);
    this.loading$.next(true);

    this.connectUsersService
      .unFollowUser({ followeeId: this.lightUser?.ID })
      .pipe(takeUntil(this.unSubscribed))
      .subscribe(
        res => {
          this.loading$.next(false);

          if (res.errors) {
            this.error$.next(res.errors[0].message);
          } else {
            this.user$.next(res?.data?.unfollow.modifiedUser);
          }
        },
        error => {
          this.error$.next(error);
          this.loading$.next(false);
        }
      );
  }

  ngOnDestroy() {
    this.unSubscribed.next();
    this.unSubscribed.complete();
  }
}
